const FORM_NAME_TASK_ADD = 'task-add';
const FORM_NAME_TASK_EDIT = 'task-edit';
const FORM_NAME_TASK_DELETE = 'task-delete';

export {
  FORM_NAME_TASK_ADD,
  FORM_NAME_TASK_EDIT,
  FORM_NAME_TASK_DELETE,
};